module.exports = __webpack_public_path__ + "img/25.ec601abf.jpg";